import axios from 'axios';
import AxiosConfig from '../../utilities/AxiosConfig';

let uploadService = {
    requestBody: {},
    base64images: [],
    progress: { filesLeft: 0, fileProgress: 0 },
    setRequestbody: (body: any) => {
        uploadService.requestBody = body
        // //console.log(uploadService.requestBody)
    },
    addImage: (img: any) => {
        let reader = new FileReader()
        reader.onloadend = function () {
            let temp: any = uploadService.base64images
            let base64image: any = reader.result
            let baseString = base64image.split(",")[1];
            let body = {
                Base64Img: baseString,
                date: Date.now()
            }
            temp.push(body)
            uploadService.base64images = temp
        }
        reader.readAsDataURL(img);
        uploadService.progress.filesLeft = uploadService.base64images.length + 1
    },
    generateHash: (base64: string) => {
        var hash = 0, i, chr
        if (base64.length === 0) return hash
        for (i = 0; i < base64.length; i++) {
            chr = base64.charCodeAt(i)
            hash = ((hash << 5) - hash) + chr
            hash |= 0
        }
        return hash;
    },
    upload: () => {
        const config = AxiosConfig.configValue();
        axios.request({
            method: "post",
            url: process.env.REACT_APP_IMG_API_URL + "/api/image",
            data: uploadService.requestBody,
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                Accept: "application/json",
                Authorization: "Bearer " + config.headers.authorization.split(" ")[1]
            },
            onUploadProgress: (ProgressEvent: any) => {
                let progress = Math.round(ProgressEvent.loaded / ProgressEvent.total * 100)
                uploadService.progress.fileProgress = progress
            }
        }).then(res => {
            uploadService.progress.filesLeft -= 1
            uploadService.progress.fileProgress = 0
            if (uploadService.progress.filesLeft === 0) {
                uploadService.base64images.length = 0
            }
            // //console.log(res)
        })
    }
}

export default uploadService